export default __webpack_public_path__ + "static/media/imgInmunologia.f3686385.png";